import LockIcon from '@mui/icons-material/Lock'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import NoEncryptionIcon from '@mui/icons-material/NoEncryption'
import VpnKeyIcon from '@mui/icons-material/VpnKey'
import VpnKeyOffIcon from '@mui/icons-material/VpnKeyOff'
import { Box } from '@mui/material'
import { useTranslate } from 'ra-core'
import { useRecordContext, useReference } from 'react-admin'

import { EventAuthorField, EventChannelField } from '../../resources/events/list'
import CircularGaugeIcon from '../CircularGaugeIcon'
import { INFO_WINDOW_TRANSLATION_KEY } from './AdvancedInfoWindow'
import FieldRow from './FieldRow'

const LastLockOperationField = ({ bookingId, helperText }) => {
  const translate = useTranslate()
  const { referenceRecord: booking, isLoading } = useReference({
    reference: 'bookings',
    id: bookingId,
    options: { enabled: !!bookingId },
  })
  const event = useRecordContext()
  if (!event || isLoading) return null

  const { action, channel, author } = event

  const isLock = action === 'force_lock_vehicle'
  const actionText = translate(`${INFO_WINDOW_TRANSLATION_KEY}.${isLock ? 'lock' : 'unlock'}`)

  let statusValue = -1

  if (channel === 'OPS') {
    statusValue = 1
  } else if (channel === 'GRAPHQL' || channel === 'WEBHOOK') {
    if (booking) {
      const { user_id, additional_driver_user_ids = [] } = booking
      const isAllowed = author.id === user_id || additional_driver_user_ids.includes(author.id)
      statusValue = isAllowed ? 0 : 2
    }
  }

  return (
    <FieldRow
      icon={
        <CircularGaugeIcon
          Icon={isLock === true ? LockIcon : LockOpenIcon}
          thresholds={[
            {
              limit: -0.5,
              color: '#ccc',
              label: { message: 'lastLockAction.noBookingData', options: { action: actionText } },
            },
            {
              limit: 0.5,
              color: '#1fd92e',
              label: { message: 'lastLockAction.userInitiated', options: { action: actionText } },
            }, // greenish
            {
              limit: 1.5,
              color: '#ed6c02',
              label: { message: 'lastLockAction.supportInitiated', options: { action: actionText } },
            }, // amber / orange
            {
              limit: Infinity,
              color: '#d32f2f',
              label: { message: `lastLockAction.unauthorizedUser`, options: { action: actionText } },
            }, // red
          ]}
          value={statusValue}
        />
      }
      helperText={helperText}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <EventAuthorField source="author" />
        <EventChannelField source="channel" tooltipPlacement="right" resource="events" />
      </Box>
    </FieldRow>
  )
}

export default LastLockOperationField
